var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"banner"}},[_c('div',{staticClass:"carousel"},[(_vm.enableSlide)?_c('splide',{attrs:{"options":_vm.options}},_vm._l((_vm.banners),function(banner){return _c('splide-slide',{key:banner.id},[_c('BannerSlide',{attrs:{"data":banner}})],1)}),1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }